const { pick } = require("lodash");

window.__mt.fn.onEditReservation = function onEditReservation(
  vm,
  $scope,
  $http,
  $timeout,
  $q,
  getReservations
) {
  var _id = "";
  let textChange = "";
  let savedPassager = false;
  let savedRoute = false;
  let getAllAvailableCars = false;
  let delimiter = window.__mt.setting.delimiter;
  let comments = "";
  let last_comment = "";

  /****
   *    Start Code
   *    It's code to cancelled or update reservation, copy and paste in other page if you need these module.
   ****/
  var _reservation = {};
  var _booking = {};
  var format = "YYYY-MM-DD HH:mm";
  var currencyDefault = "EUR";

  var toggle = false;
  var hasChange = "";
  var phone_number = "";
  var iti_r;
  var origin, destination, _distance;
  var current_date = new Date();
  var base_price_provider = 0;
  current_date.setDate(current_date.getDate() + 1);
  vm._show = {
    load: "one",
  };
  vm.comment = "";
  vm.data = {};
  vm.old_data = {};
  vm.pickup_departure = true;
  vm.calendar = {
    oneway: true,
  };
  vm.isEdit = false;
  vm.showClientInformation = false;
  vm.editingSection = null; // Puede ser: null, 'route', 'vehicle', 'client', 'extras'
  vm.showVehicleOptions = false; // Variable para controlar la vista de selección de vehículos
  vm.distance = {};
  vm.exchange_convertion = window.__mt.setting.exchange.convertion;
  vm.cancellationHasInsurance = false;
  vm.cancellationCanBeRefunded = false;
  vm.cancelRefundEligible = null;

  vm.toggleEdit = function(id, email) {
    vm.isEdit = !vm.isEdit;
    if (vm.isEdit) {
      vm.edit(id, email);
    }
  };

  vm.canEdit = function(editable) {
    return editable;
  };

  function hasInsuranceProtection(reservation) {
    return Boolean(
      reservation &&
        (reservation.insurance === true ||
          reservation.insurance === 1 ||
          reservation.insurance === "1" ||
          reservation.has_insurance === true)
    );
  }

  function getCancellationPickupDate(reservation) {
    var pickup =
      reservation &&
      (reservation.pickUpDate ||
        reservation.pickup_datetime ||
        reservation.pickup_date ||
        (reservation.trip && reservation.trip.pickUpDate));

    if (!pickup) {
      return null;
    }

    var pickupDate = window.__mt.fn.getDate(pickup);

    if (!pickupDate || Number.isNaN(pickupDate.getTime())) {
      return null;
    }

    return pickupDate;
  }

  function canCancelBeforePickup(reservation) {
    var pickupDate = getCancellationPickupDate(reservation);
    return Boolean(pickupDate && new Date().getTime() < pickupDate.getTime() - 2 * 60 * 60 * 1000);
  }

  function isRefundEligibleForCancellation(reservation) {
    var pickupDate = getCancellationPickupDate(reservation);
    if (!pickupDate) {
      return false;
    }

    var cutoffHours = hasInsuranceProtection(reservation) ? 2 : 24;
    return new Date().getTime() < pickupDate.getTime() - cutoffHours * 60 * 60 * 1000;
  }

  function isSuccessfulCancellationRefundable(response) {
    if (typeof response.could_refund !== "undefined") {
      return Boolean(response.could_refund);
    }

    return response.refund_status !== "not_refundable" && response.refund_status !== "none";
  }

  vm.canCancelBooking = function(reservation) {
    if (!reservation) return false;
    var currentStatus = (reservation.status || reservation.woo_status || "").toLowerCase();
    if (currentStatus === "cancelled" || currentStatus === "refunded" || currentStatus === "cancel") return false;
    return canCancelBeforePickup(reservation);
  };

  // Función para controlar qué sección está en modo edición
  vm.setEditingSection = function(section) {
    // Si se hace clic en la misma sección, la cerramos
    if (vm.editingSection === section) {
      vm.editingSection = null;
      vm.showClientInformation = false;
      vm.submit = false; // Resetear el estado de submit al cerrar
    } else {
      // Cerrar todas las secciones
      vm.editingSection = section;
      vm.showClientInformation = section === "client";
      vm.submit = false; // Resetear el estado de submit al cambiar de sección
    }
  };

  // Función para cerrar la sección actual (para botones Cancel)
  vm.closeEditingSection = function() {
    vm.editingSection = null;
    vm.showClientInformation = false;
    vm.submit = false; // Resetear el estado de submit al cerrar
  };

  vm.timeoutStop = function() {
    window.__mt.setting.idleStop();
  };

  vm.limitTimeToEdit = function(date) {
    var today = new Date();
    var pickup = window.__mt.fn.getDate(date);

    today = today.setDate(today.getDate() + window.__mt.setting.minimum_time);

    return today < pickup;
  };

  vm.isDatePassed = function(date) {
    if (!date) return false;
    var now = new Date();
    var d = window.__mt.fn.getDate(date);
    return d < now;
  };

  vm.edit = function(id, email) {
    getBooking(id, email);
  };

  vm.cancel = function(reservation) {
    vm._show.load = "one";
    vm.comment = "";
    vm.cancelRefundEligible = null;
    //_reservation = reservation;
    _id = reservation.booking_id || reservation.Id || reservation;
    var params = {
      id: reservation.booking_id || reservation.Id || reservation,
      email: reservation.email || vm.prof.customerEmail,
    };

    vm.loading = true;
    $http
      .post(window.__mt.setting.api_booking, params)
      .then(getCancelBookingSuccess, getBookingError);
  };

  vm.onCancel = function() {
    vm._show.load = "load";
    vm.cancelRefundEligible = null;
    var params = {
      id: _reservation.bookingReference,
      editable: _reservation.editable,
      pickup: _reservation.pickUpDate,
      lang: window.__mt.ln.lang,
      comment: vm.comment,
    };
    $http
      .post(window.__mt.setting.api_cancel, params)
      .then(onCancelSuccess, onCancelError);
  };

  vm.changeCalendar = function(id, cal, type = null) {
    vm.calendar[id] = false;

    $timeout(() => {
      vm.openCalendar(cal, type);
    }, 100);
  };

  vm.openCalendar = function(id, type = null) {
    //showAlert(vm.data.trip,false);// rountrip =  false
    //if (!vm.calendar.oneway) {
    vm.msn.selected = type;
    $timeout(() => {
      $("#" + id)
        .data("daterangepicker")
        .toggle();
    }, 100);
    //}
  };

  vm.recommendedTime = function(date, time_google, time, type) {
    var current = window.__mt.fn.getDate(date);
    var delay = getTimeDelay(time, type);
    var sum_time = time_google / 60 + delay;
    current.setMinutes(current.getMinutes() - sum_time);

    return current;
  };

  let flip = 0;
  vm.showPassenger = function() {
    toggle = !toggle;
    $("#pax-view-pro").toggle(flip++ % 2 === 0);
    /**if (!toggle) {
            requote();
        }**/
  };
  let changedPersons = false;
  vm.savePassager = function() {
    vm.data.savePassager = false;
    changedPersons = true;
    savedPassager = true;
    requote();
    vm.showChangePassagers = false;
  };

  vm.handlePassengerSave = function() {
    if (vm.totalPassages > vm.car.maxPassengers) {
      vm.closeEditingSection();
      vm.listCars();
    } else {
      vm.savePassager();
      vm.closeEditingSection();
    }
  };

  function defaultPassagers() {
    vm.data.children = vm.old_data.children;
    vm.data.adults = vm.old_data.adults;
    vm.data.infants = vm.old_data.infants;
    vm._search_confirm.adults = vm.old_data.adults;
    vm._search_confirm.infants = vm.old_data.infants;
    vm._search_confirm.children = vm.old_data.children;
    $timeout(function() {
      $scope.$apply();
    });
  }
  function validPassagers() {
    let valid = false;
    vm.totalPassages =
      Number.parseInt(vm.data.children) +
      Number.parseInt(vm.data.adults) +
      Number.parseInt(vm.data.infants);
    let old_total =
      Number.parseInt(vm.old_data.children) +
      Number.parseInt(vm.old_data.adults) +
      Number.parseInt(vm.old_data.infants);
    if (
      vm.data.children != vm.old_data.children ||
      vm.data.adults != vm.old_data.adults ||
      vm.data.infants != vm.old_data.infants
    ) {
      valid = true;
    }

    return valid;
  }
  /** Action hiden checkbox  passagers**/
  $(document).mouseup(function(e) {
    var container = $("#pax-view-pro");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      container.hide();
      flip = 0;
    }
  });

  vm.addPax = function(pax) {
    vm._search_confirm[pax] += 1;
    vm.data[pax] += 1;
    savedPassager = false;
    vm.showChangePassagers = validPassagers();

    // Calcular total de pasajeros
    vm.totalPassages =
      Number.parseInt(vm.data.children) +
      Number.parseInt(vm.data.adults) +
      Number.parseInt(vm.data.infants);
  };

  vm.removePax = function(pax, min) {
    if (vm._search_confirm[pax] - 1 >= min) {
      vm._search_confirm[pax] -= 1;
      vm.data[pax] -= 1;
    }
    savedPassager = false;
    vm.showChangePassagers = validPassagers();

    // Recalcular total de pasajeros
    vm.totalPassages =
      Number.parseInt(vm.data.children) +
      Number.parseInt(vm.data.adults) +
      Number.parseInt(vm.data.infants);
  };

  vm.hasChangeField = function(_old, _new, key = null) {
    if (vm.form && vm.form.$valid && vm.submit && _old != _new) {
      writeTextChanges(key, _old, _new);
    }
    return _old == _new;
  };

  vm.goBack = function() {
    // $(".ca-container").hide();
    // $("#id-reservation").show();
  };

  function hasChanges() {
    var d = JSON.parse(JSON.stringify(vm.data));
    if (d.customerPhone) {
      d.customerPhone = d.customerPhone.replace(/\s/g, "");
      var _hasChange = JSON.stringify(d);
      return _hasChange != hasChange || hasChangeCar();
    }
    return false;
  }
  function hasChangeCar() {
    if (vm.qt.selected) {
      let _old = JSON.stringify(vm.data.car);
      let _new = JSON.stringify(vm.car);
      return _old != _new;
    }
    return false;
  }

  function writeTextChanges(key, oldText, newTxt) {
    let newText = newTxt.replace(/\r?\n|\r/g, " ");
    let text = `<b>${key}</b> : <del>${oldText}</del> > ${newText}<br/>`;
    let arrText = textChange.split("\n");
    let repeat = false;

    for (let index = 0; index < arrText.length; index++) {
      const element = arrText[index];
      if (element == text) {
        repeat = true;
        break;
      }
    }

    if (!repeat) {
      textChange += `<b>${key}</b> : <del>${oldText}</del> > ${newText}<br/>\n`;
    }
  }

  function getBooking(id, email) {
    var user = __mt.setting.user || {};

    var params = {
      id: id,
      user_id: user.id,
      user_type: user.type,
    };
    vm.loading = true;
    $http
      .post(window.__mt.setting.api_booking, params)
      .then(getBookingSuccess, getBookingError);
  }

  function getBookingSuccess(data) {
    var response = data.data;
    if (response.status == 200) {
      reset();
      _booking = response.booking;
      vm.loading = false;
      initEdit();
      //$("#c-modal-edit").modal("show");
      //$(".ca-container").hide();
      initModal();
    } else {
      getBookingError(data);
    }
  }

  function initModal() {
    if (iti_r) {
      iti_r.destroy();
    }
    $("#id-modify-booking").show();
    $("#edit-modal").modal("show");
    $("#nav-home-tab").tab("show");

    $("#c-edit-route-info-1, #c-btn-change").addClass("d-none");
    $("#c-edit-route-info-2, #c-btn-change").addClass("d-none");
    $("#c-btns-footer, #c-default-route-information").removeClass("d-none");
    window.__mt.setting.idleStart();
  }

  function getCancelBookingSuccess(data) {
    var response = data.data;
    if (response.status == 200) {
      _reservation = window.__mt.fn.findObject(
        response.booking.bookedDetails,
        "bookingReference",
        _id
      );
      vm.cancellationHasInsurance =
        hasInsuranceProtection(_reservation) || hasInsuranceProtection(response.booking);
      _reservation.has_insurance = vm.cancellationHasInsurance;
      vm.cancellationCanBeRefunded = isRefundEligibleForCancellation(_reservation);
      vm.editableCancel = vm.canCancelBooking(_reservation);
      vm.loading = false;
      $("#c-modal-cancel").modal("show");
    } else {
      getBookingError(data);
    }
  }

  function getBookingError(data) {
    vm.loading = false;
    $("#c-modal-feedback").modal("show");
  }

  function onCancelSuccess(data) {
    var res = data.data;

    if (res.code == 200) {
      vm.cancelRefundEligible = isSuccessfulCancellationRefundable(res);
      if (res.type == "integrator") {
        vm._show.load = "integrator_success";
      } else {
        vm._show.load = vm.cancelRefundEligible ? "success" : "success_no_refund";
      }
      getReservations();
    } else if (res.code == 404) {
      vm._show.load = "time";
    } else {
      onCancelError(data);
    }
  }

  function onCancelError(data) {
    vm._show.load = "error";
    console.log(data);
  }

    function initEdit() {
        $("#pax-view-pro").hide();
        var detail = window.__mt.fn.findObject(_booking.bookedDetails, 'bookingReference', _id) || _booking.bookedDetails[0];
        textChange = "";
        vm.submit = false;
        vm.data = {};
        vm.data.trip = {};
        vm.data.price = {};

    var pickupDate = detail.pickUpDate;
    var externalDate = detail.departureTransportDate;
    var transportDate = detail.arrivalTransportDate;

    if (externalDate) {
      externalDate = externalDate.replace(":00.0", "");
    }

    if (pickupDate) {
      pickupDate = pickupDate.replace(":00.0", "");
    }

    if (transportDate) {
      transportDate = transportDate.replace(":00.0", "");
    }

    console.log('booking',_booking); 
    console.log('detail',   detail); 

    vm.data.customerEmail = _booking.customerEmail;
    vm.data.confirm_email = _booking.customerEmail;
    vm.data.customerFirstName = _booking.customerFirstName;
    vm.data.customerLastName = _booking.customerLastName;
    vm.data.specialRequirements = getLastComment(_booking.specialRequirements);
    vm.data.adults = _booking.adults;
    vm.data.infants = _booking.infants;
    vm.data.children = _booking.childs;
    vm.data.customerCountry = _booking.customerCountry;
    vm.data.editable = detail.editable;
    vm.data.insurance = detail.insurance || _booking.insurance || false;
    vm.data.has_insurance = hasInsuranceProtection(detail) || hasInsuranceProtection(_booking);
    vm.data.customerPhone = _booking.customerPhone
      .replace(/\(.*\)\s/g, "")
      .replace(/\s/g, "");

    vm.data.trip.bookingReference = detail.bookingReference;
    vm.data.trip.dropoff = detail.dropoff.replace(/\([\w\d\s]{5,}\)/g, "");
    vm.data.trip.dropoffType = detail.dropoffType;
    vm.data.trip.departureTransportDate = externalDate;
    vm.data.trip.departureTransportLine = detail.departureTransportLine;
    vm.data.trip.departureTransportLocator = detail.departureTransportLocator;

    vm.data.trip.pickup = detail.pickup.replace(/\([\w\d\s]{5,}\)/g, "");
    vm.data.trip.arrivalTransportDate = transportDate;
    vm.data.trip.arrivalTransportLine = detail.arrivalTransportLine;
    vm.data.trip.arrivalTransportLocator = detail.arrivalTransportLocator;
    vm.data.trip.pickupType = detail.pickupType;
    vm.data.trip.pickUpDate = pickupDate;
    vm.cancellationHasInsurance = hasInsuranceProtection(vm.data) || hasInsuranceProtection(detail);
    vm.data.price.totalPrice = _booking.totalPrice.transfersPrice;
    vm.data.price.currency = _booking.totalPrice.currency || currencyDefault;

    // Agregar propiedades necesarias para sendEmailVoucher e invoice
    vm.data.bookingReference = detail.bookingReference;
    vm.data.Id = detail.bookingReference;
    vm.data.booking_id = detail.bookingReference;
    vm.data.email = _booking.customerEmail;

    vm.data.transport_id = _booking.bookedTransfer.transportId;
    vm.data.provider_id = detail.providerId;
    vm.data.provider_price_id = detail.providerPriceId;
    vm.data.hasMeet = _booking.hasMeet;
    vm.data.meetAndGreet = _booking.meetAndGreet;
    //vm.data.type_reservation = detail.bookingExternalReference;
    vm.data.type_reservation = _booking.roundTrip;
    vm.data.status = detail.status;
    /** datos del vehículo **/
    vm.data.car = {};
    vm.data.car.transportId = _booking.bookedTransfer.transportId;
    vm.data.car.imageURL = _booking.bookedTransfer.imageURL;
    vm.data.car.maxPassengers = _booking.bookedTransfer.maxPassengers;
    vm.data.car.minPassengers = _booking.bookedTransfer.minPassengers;
    vm.data.car.price = _booking.bookedTransfer.price;
    vm.data.car.suitcases = _booking.bookedTransfer.suitcases;
    vm.data.car.transportName = _booking.bookedTransfer.transportName;
    /** end datos del vehículo **/
    vm._search_confirm.adults = _booking.adults;
    vm._search_confirm.infants = _booking.infants;
    vm._search_confirm.children = _booking.childs;

    vm._search_confirm.search_from.id = 1;
    vm._search_confirm.search_to.id = 1;

    vm._search_confirm.search_from.lat = detail.pickUpLat;
    vm._search_confirm.search_from.lng = detail.pickUpLng;
    vm._search_confirm.search_to.lat = detail.dropoffLat;
    vm._search_confirm.search_to.lng = detail.dropoffLng;
    /** Datos del cliente **/
    vm.data.client_key = _booking.clientKey;
    vm.data.client_id = _booking.clientId;
    $timeout(() => {
      initPhoneReservation(vm.data.customerCountry);
    }, 300);
    labelTrip();
    getDistance();
    showAlertInit();

    hasChange = JSON.stringify(vm.data);
    vm.old_data = JSON.parse(hasChange);
    vm.totalPassages =
      Number.parseInt(vm.data.children) +
      Number.parseInt(vm.data.adults) +
      Number.parseInt(vm.data.infants);
    vm.typePickup = vm.data.trip.pickupType;
    vm.typeDropoff = vm.data.trip.dropoffType;
    vm.car = vm.data.car;
    base_price_provider = detail.providerTotalPrice;
    
  }

  function initPhoneReservation(country) {
    var input = document.querySelector("#phone_r");
    console.log(input);
    iti_r = window.intlTelInput(input, {
      utilsScript: window.__mt.setting.utils_script_url,
      initialCountry: "auto",
      separateDialCode: true,
      initialCountry: country || "auto",
      localizedCountries: window.__mt.setting.format_codes,
      preferredCountries: window.__mt.setting.preferred_countries,
      /*geoIpLookup: function (success, failure) {
                success(countryCode);
            },*/
    });

    input.addEventListener("blur", function() {
      if (input.value.trim()) {
        var vali = true;
        if (!iti_r.isValidNumber()) {
          vali = false;
        }
      }
    });

    input.addEventListener("countrychange", function() {
      var country = iti_r.getSelectedCountryData();
      if (country && country.dialCode) {
        //$("#country").val(country.iso2.toUpperCase());
        phone_number = country.dialCode;
        $scope.$apply(() => {
          vm.data.customerCountry = country.iso2.toUpperCase();
        });
      }
    });
  }

  function labelTrip() {
    var lang = window.__mt.ln;
    switch (vm.data.trip.pickupType) {
      case "airport":
        vm.ln.type_pickup = lang.pickup_date_flight;
        vm.ln.type_pickup_en = "Flight arrival date & time";
        break;
      case "train_station":
        vm.ln.type_pickup = lang.pickup_date_train;
        vm.ln.type_pickup_en = "Train arrival date & time";
        break;
      case "port":
        vm.ln.type_pickup = lang.pickup_date_port;
        vm.ln.type_pickup_en = "Disembarkation date & time";
        break;
      default:
        vm.ln.type_pickup = lang.pickup_date_address;
        vm.ln.type_pickup_en = "Pickup date & time";
        break;
    }

    switch (vm.data.trip.dropoffType) {
      case "airport":
        vm.ln.type_dropoff = lang.dropoff_date_flight;
        vm.ln.type_dropoff_en = "Flight arrival date & time";
        break;
      case "train_station":
        vm.ln.type_dropoff = lang.dropoff_date_train;
        vm.ln.type_dropoff_en = "Train arrival date & time";
        break;
      case "port":
        vm.ln.type_dropoff = lang.dropoff_date_port;
        vm.ln.type_dropoff_en = "Disembarkation date & time";
        break;
      default:
        vm.ln.type_dropoff = lang.dropoff_date_address;
        vm.ln.type_dropoff_en = "Pickup date & time";
        break;
    }
  }

  function initPickers() {
    var minDate = window.__mt.fn.getDate(vm.data.trip.pickUpDate);
    minDate.setDate(minDate.getDate() - 1);
    var today = window.__mt.fn.getDate();
    //var arrival_original = vm.data.trip.pickUpDate;
    var dropoffdate = vm.data.trip.departureTransportDate;

    /*if (vm.data.trip.pickup == "address" && vm.data.trip.dropoff != "address") {
            var datepicker_init = vm.data.trip.pickUpDate;
            var date_init = vm.recommendedTime(datepicker_init, 0, 0, vm.data.trip.dropoffType);
            vm.data.trip.pickUpDate = window.__mt.fn.formatDate(date_init, 'yyyy-MM-dd HH:mm');
        }*/

    //recotizeReturn(vm.checkout.quote.departure_date,  vm.data.trip.pickUpDate);

    var arrival_date = window.__mt.fn.getDate(vm.data.trip.pickUpDate);

    $("#arrival_date").daterangepicker({
      singleDatePicker: true,
      autoApply: true,
      startDate: arrival_date,
      //minDate: today,
      timePicker: true,
      timePicker24Hour: true,
      timePickerIncrement: 5,
      drops: "up",
      locale: {
        format: format,
        daysOfWeek: window.__mt.setting.format.daysOfWeek,
        monthNames: window.__mt.setting.format.monthNames,
        firstDay: 0,
        applyLabel: window.__mt.ln.ok,
        cancelLabel: window.__mt.ln.cancel,
      },
    });

    calendarPickup();
    var t = window.__mt.fn.getDate(vm.data.trip.pickUpDate - 1);
    $("#arrival_date_c").daterangepicker({
      singleDatePicker: true,
      autoApply: true,
      startDate: arrival_date,
      //minDate: today,
      timePicker: true,
      timePicker24Hour: true,
      timePickerIncrement: 5,
      drops: "up",
      locale: {
        format: format,
        daysOfWeek: window.__mt.setting.format.daysOfWeek,
        monthNames: window.__mt.setting.format.monthNames,
        firstDay: 0,
        applyLabel: window.__mt.ln.ok,
        cancelLabel: window.__mt.ln.cancel,
      },
    });

    calendarPickupExtra();

    $("#dropoff_departure_date").daterangepicker({
      singleDatePicker: true,
      autoApply: true,
      startDate: dropoffdate,
      //minDate: today,
      timePicker: true,
      timePicker24Hour: true,
      timePickerIncrement: 5,
      drops: "up",
      locale: {
        format: format,
        daysOfWeek: window.__mt.setting.format.daysOfWeek,
        monthNames: window.__mt.setting.format.monthNames,
        firstDay: 0,
        applyLabel: window.__mt.ln.ok,
        cancelLabel: window.__mt.ln.cancel,
      },
    });

    calendarDropOff();
  }

  function getTimeDelay(delay, type) {
    var time = delay;
    if (delay == 0 || delay == 2) {
      switch (type) {
        case "airport":
          time = window.__mt.setting.minimum_time_airport + delay;
          break;
        case "train_station":
          time = window.__mt.setting.minimum_time_train + delay;
          break;
        case "port":
          time = window.__mt.setting.minimum_time_port + delay;
          break;
        default:
          time = delay;
          break;
      }
    }

    return time;
  }

  function calendarPickup(calentim) {
    $("#arrival_date").on("show.daterangepicker", function(ev, picker) {
      getMessagePicker("pickup");
    });

    $("#arrival_date").on("hide.daterangepicker", function(ev, picker) {
      var currentDate = picker.startDate;

      var $datetimepicker = currentDate.format(format);

      $scope.$apply(() => {
        vm.loading = true;
        vm.data.trip.pickUpDate = $datetimepicker;
        vm.data.trip.arrivalTransportDate = $datetimepicker;
        vm.pickup_departure = !validPickupDate();
      });
      var t = window.__mt.fn.getDate(vm.data.trip.pickUpDate - 1);

      $("#arrival_date").daterangepicker({
        singleDatePicker: true,
        autoApply: true,
        startDate: vm.data.trip.pickUpDate,
        // minDate: today,
        timePicker: true,
        timePicker24Hour: true,
        timePickerIncrement: 5,
        drops: "up",
        locale: {
          format: format,
          daysOfWeek: window.__mt.setting.format.daysOfWeek,
          monthNames: window.__mt.setting.format.monthNames,
          firstDay: 0,
          applyLabel: window.__mt.ln.ok,
          cancelLabel: window.__mt.ln.cancel,
        },
      });

      calendarPickup();

      requote();
    });
  }

  function calendarPickupExtra(calentim) {
    $("#arrival_date_c").on("show.daterangepicker", function(ev, picker) {
      getMessagePicker(""); /**pendiente**/
    });
    $("#arrival_date_c").on("hide.daterangepicker", function(ev, picker) {
      vm.msn.selected = "";
      var currentDate = picker.startDate;

      var $datetimepicker = currentDate.format(format);

      $scope.$apply(() => {
        vm.loading = true;
        vm.data.trip.pickUpDate = $datetimepicker;

        vm.pickup_departure = !validPickupDate();
      });

      requote();
    });
  }

  function calendarDropOff(calentim, currentDate) {
    $("#dropoff_departure_date").on("show.daterangepicker", function(
      ev,
      picker
    ) {
      getMessagePicker("pickup");
    });
    $("#dropoff_departure_date").on("hide.daterangepicker", function(
      ev,
      picker
    ) {
      vm.msn.selected = "";
      var currentDate = picker.startDate;
      var $datetimepicker = currentDate.format(format);

      var arrival_date = vm.data.trip.pickUpDate;
      var calendar_arrival_date = $("#arrival_date").data("daterangepicker");
      var calendar_arrival_date_c = $("#arrival_date_c").data(
        "daterangepicker"
      );
      var today = window.__mt.fn.getDate();

      $scope.$apply(() => {
        vm.loading = true;
        var datepicker = $datetimepicker;
        var date = vm.recommendedTime(
          datepicker,
          vm.distance.duration.value || 0,
          0,
          vm.data.trip.dropoffType
        );
        vm.data.trip.departureTransportDate = datepicker;

        var datepicker_obj = window.__mt.fn.getDate(arrival_date);
        var d = window.__mt.fn.formatDate(date, "yyyy-MM-dd HH:mm");
        calendar_arrival_date.setStartDate(d);
        calendar_arrival_date_c.setStartDate(d);
        vm.data.trip.pickUpDate = d;
        vm.data.trip.arrivalTransportDate = d;
        vm.pickup_departure = validPickupDate();
      });
      var t = window.__mt.fn.getDate(vm.data.trip.pickUpDate - 1);
      $("#arrival_date_c").daterangepicker({
        singleDatePicker: true,
        autoApply: true,
        startDate: vm.data.trip.pickUpDate,
        minDate: today,
        timePicker: true,
        timePicker24Hour: true,
        timePickerIncrement: 5,
        drops: "up",
        locale: {
          format: format,
          daysOfWeek: window.__mt.setting.format.daysOfWeek,
          monthNames: window.__mt.setting.format.monthNames,
          firstDay: 0,
          applyLabel: window.__mt.ln.ok,
          cancelLabel: window.__mt.ln.cancel,
        },
      });

      calendarPickupExtra();

      requote();
    });
  }

  function validPickupDate() {
    var quote = vm.data.trip;
    var transport = /*sessions && sessions.length > 1 ? sessions[0] :*/ {};
    var delay = getTimeDelay(transport.delayTime || 0, quote.dropoffType);
    var minimum_time = (delay || 0) + (vm.distance.duration.value / 60 || 0);
    var valid = false;
    if (quote.dropoffType != "address" && quote.pickupType == "address") {
      var pickup = quote.pickUpDate;
      var dropoff = quote.departureTransportDate || null;
      valid = validMinTime(pickup, dropoff, minimum_time, "pickup_departure");
    }

    return valid;
  }

  function validMinTime(date_in, date_out, time, msn) {
    var valid = true;
    if (date_in && date_out) {
      var dateDeparture = window.__mt.fn.getDate(date_out);
      var datePickup = window.__mt.fn.getDate(date_in);
      datePickup.setMinutes(datePickup.getMinutes() + time);
      valid = +dateDeparture <= +datePickup;
      vm[msn] = !valid;
    }
    return valid;
  }

  function getDistance() {
    origin =
      vm._search_confirm.search_from.lat +
      "," +
      vm._search_confirm.search_from.lng;
    destination =
      vm._search_confirm.search_to.lat + "," + vm._search_confirm.search_to.lng;

    var params = {
      params: {
        origins: origin,
        destinations: destination,
      },
    };
    $http
      .get(window.__mt.setting.api_distance, params)
      .then(onSuccessDistance, console.log);
  }

  function onSuccessDistance(data) {
    var response = data.data;
    if (response.status == "OK") {
      var distance = {};
      distance.data = response;
      distance.origin = origin;
      distance.destination = destination;
      _distance = distance;
      setDistance();
    }
  }

  function setDistance() {
    if (_distance) {
      if (_distance.data && _distance.data.rows && _distance.data.rows.length) {
        vm.distance = _distance.data.rows[0].elements.length
          ? _distance.data.rows[0].elements[0]
          : vm.distance;
        initPickers();
        console.log(vm.distance);
      }
    }
  }

  /*** SEARCH ***/
  window.map_load = window.map_load || null;
  var marker;
  var map;
  var _list = "";
  var autocompleteService;
  var params = {};
  var service;
  var stripe = Stripe(window.__mt.setting.stripe);
  var aux_trip = {};
  vm.loading_search = false;
  vm.loading = false;
  vm.routeChangeError = false;
  vm.results = [];
  vm.results_gm = [];
  vm.results_to = [];
  vm.results_gm_to = [];
  vm.results_pr = [];
  vm.results_pr_to = [];
  vm.search_in_places = false;
  vm.search_in_places_to = false;
  vm.qt = {
    type: "oneway",
    rs: true,
  };
  vm.nTransport = {};
  vm._search = {
    adults: 1,
    children: 0,
    infants: 0,
    search_from: {},
    search_to: {},
  };

  vm._search_confirm = {
    adults: 1,
    children: 0,
    infants: 0,
    search_from: {},
    search_to: {},
  };

  vm._edit = {
    from: false,
    to: false,
  };
  vm.valid_confirm = false;

  vm.search = function(v, model, type) {
    vm[v] = true;
    if (type == "from") {
      vm.results = [];
      vm.results_gm = [];
      vm.results_pr = [];
      _list = "";
    } else {
      vm.results_to = [];
      vm.results_gm_to = [];
      vm.results_pr_to = [];
      _list = "_to";
    }
    if (!model && model.length < 2) {
      return;
    }

    vm.loading_search = true;

    params = {
      params: {
        query: model,
        lang: window.__mt.ln.lang,
      },
    };

    // Solo busca en la API de MyTransfers, NO en Google Maps
    get(window.__mt.setting.api_search, params)
      .then(responseMT)
      .catch(console.log);
  };

  vm.searchInPlaces = function(show, type) {
    // Activa el flag para indicar que se quiere buscar en Google Maps
    if (type == "_to") {
      vm.search_in_places_to = true;
    } else {
      vm.search_in_places = true;
    }

    vm.loading_search = true;
    findInPlaces();
  };

  function findInPlaces() {
    // Limpia las predictions para mostrar resultados de Google
    vm["results_pr" + _list] = [];

    // Carga el script de Google Maps si no existe
    if (!map_load && !window.google) {
      window.__mt.fn.getScript(
        window.__mt.setting.google_map,
        {},
        onLoadResults
      );
    } else {
      onLoadResults();
    }
    vm.loading_search = false;
  }

  vm.editReservation = function(type, val) {
    vm._edit[type] = val; //vm._edit.from
  };

  vm.iconType = function(item) {
    var icon = "";
    var type = item.type || getTypeGM(item);
    switch (type) {
      case "train_station":
        icon = "fa fa-train";
        break;
      case "port":
        icon = "fa fa-ship";
        break;
      case "airport":
        icon = "fa fa-plane";
        break;
      default:
        icon = "fa fa-map-marker";
        break;
    }
    return [icon];
  };

  vm.acceptChange = function() {
    if (vm.qt.type == "options" && vm.qt.transport) {
      vm.qt.selected = true;
      vm.car = vm.qt.transport;
      $("#c-modal-notification").modal("hide");
    }

    if (vm.qt.type == "no-found") {
      vm.totalPassages =
        Number.parseInt(vm.data.children) +
        Number.parseInt(vm.data.adults) +
        Number.parseInt(vm.data.infants);
      $("#c-modal-notification").modal("hide");
      /**save people child, infants and adults**/
      if (savedPassager && validPassagers()) {
        if (vm.totalPassages > vm.car.maxPassengers) {
          vm.showChangePassagers = true;
          savedPassager = false;
          $("#pax-view-pro").toggle();
        } else {
          vm.data.savePassager = true;
          vm.qt.rs = true;
        }
      }
      /**save route pickup or dropoff**/
      if (savedRoute) {
        /**
                if(total <= vm.data.car.maxPassengers){
                    vm.data.saveTypeDestination = true;
                    vm.qt.rs = true;
                }else{
                    vm.data.saveTypeDestination = false;
                }
                 **/
      }
    }
  };

  vm.selectResult = function(item, source, type, show, dt) {
    vm[show] = false;

    if (source == "mt") {
      vm._search_confirm[type] = item.name;
      vm._search_confirm[type + "_view"] = item.name;
    } else {
      vm._search_confirm[type] =
        item.name ||
        item.formatted_address ||
        item.description ||
        item.structured_formatting.main_text;
      vm._search_confirm[type + "_view"] =
        item.name ||
        item.formatted_address ||
        item.description ||
        item.structured_formatting.main_text;
    }

    vm._search_confirm["search_" + type] = item;
    vm._search_confirm["search_" + type].source = source;

    //vm.editReservation(type, false);
    changePoint(item, dt, type);
    showTooltip(type, item);
  };

  vm.closeChangeRoute = function() {
    vm.valid_confirm = true;
    savedRoute = true;
    vm.routeChangeError = false;

    if (vm.data.trip.pickupType == "address") {
      if (vm._search_confirm.from) {
        vm._search_confirm.to = vm.data.trip.dropoff;
      } else {
        return;
      }
    }
    if (vm.data.trip.dropoffType == "address") {
      if (vm._search_confirm.to) {
        vm._search_confirm.from = vm.data.trip.pickup;
      } else {
        return;
      }
    }
    /** if (!vm._search_confirm.to || !vm._search_confirm.from) {
             return
         }**/

    // Guardar valores antiguos para poder restaurarlos si hay error
    vm._backup_search = {
      from: angular.copy(vm.data.trip.pickup),
      to: angular.copy(vm.data.trip.dropoff),
      search_from: angular.copy(vm._search_confirm.search_from),
      search_to: angular.copy(vm._search_confirm.search_to),
    };

    vm._edit.from = false;
    changeConfirmTrip();
    requote();
    showAlert(vm.data.trip, false); // rountrip =  false
  };

  vm.resetRouteChanges = function() {
    vm.routeChangeError = false;

    // Restaurar valores antiguos si existen
    if (vm._backup_search) {
      vm.data.trip.pickup = vm._backup_search.from;
      vm.data.trip.dropoff = vm._backup_search.to;

      if (vm._backup_search.search_from) {
        vm._search_confirm.search_from = vm._backup_search.search_from;
      }
      if (vm._backup_search.search_to) {
        vm._search_confirm.search_to = vm._backup_search.search_to;
      }

      vm._search_confirm.from = false;
      vm._search_confirm.to = false;

      delete vm._backup_search;
    }

    savedRoute = false;
  };

  vm.onFocus = function(show, type) {
    if (vm["results" + type].length || vm["results_gm" + type].length) {
      vm[show] = true;
    }
  };

  vm.listCars = function() {
    getAllAvailableCars = true;
    vm.showVehicleOptions = true; // Mostrar la vista de opciones de vehículos
    requote(true);
  };

  vm.selectOption = function(car) {
    optionCarDeselect();
    car.selected = true;
    vm.qt.transport = car;
    vm.qt.rs = true;
    vm.acceptChange();
    // Después de seleccionar vehículo, regresar a vista de edición
    vm.showVehicleOptions = false; // Ocultar la vista de opciones
    vm.setEditingSection("vehicle");
  };

  vm.showPrice = function(option) {
    // console.log('show price',option);
    // console.log('vm.data',vm.data);
    var text = 0;
    if (
      vm.data &&
      option &&
      vm.data.price &&
      vm.data.price.totalPrice < option.price
    ) {
      text = (option.price - vm.data.price.totalPrice) * vm.exchange_convertion;
    }
    return text;
  };

  vm.save = function() {
    vm.submit = true;
    vm.confirm_email = validConfirmEmail();

    if (vm.totalPassages > vm.car.maxPassengers) {
      //defaultPassagers();
      // NOTA: No se resetea vm.submit a false aquí para que los campos inválidos
      // mantengan la clase 'is-invalid' visible para el usuario
      // vm.submit = false;
      return 0;
    }

    if (
      !vm.form ||
      !vm.form.$valid ||
      !vm.pickup_departure ||
      !vm.confirm_email
    ) {
      // NOTA: No se resetea vm.submit a false cuando la validación falla
      // Esto permite que ng-class aplique 'is-invalid' a los campos que tienen errores
      // Anteriormente se establecía vm.submit = false aquí, lo que impedía mostrar los errores
      // vm.submit = false;
      return 0;
    }

    if (hasChanges() && vm.qt && vm.qt.rs && vm.qt.type != "no-found") {
      $("#c-modal-confirmation").modal("show");
      console.log("HUBO CAMBIO");
    } else {
      vm.submit = false;
      $("#c-modal-edit").modal("hide");
      console.log("NO HUBO CAMBIO o NO CUMPLE CON LA SELECCION");
    }
  };

  vm.onSave = function() {
    onSave();
  };

  vm.isHubToHub = function(quote) {
    return (
      quote && quote.dropoffType != "address" && quote.pickupType != "address"
    );
  };

  vm.cancelChangeRoute = function() {
    // Limpiar dropdowns
    vm.showfrom = false;
    vm.showto = false;
    vm._edit.from = false;

    // Restaurar valores originales de la ruta desde old_data
    if (vm.old_data && vm.old_data.trip) {
      vm.data.trip.pickup = vm.old_data.trip.pickup;
      vm.data.trip.dropoff = vm.old_data.trip.dropoff;
      vm.data.trip.pickupType = vm.old_data.trip.pickupType;
      vm.data.trip.dropoffType = vm.old_data.trip.dropoffType;
      vm.data.trip.pickUpLat = vm.old_data.trip.pickUpLat;
      vm.data.trip.pickUpLng = vm.old_data.trip.pickUpLng;
      vm.data.trip.dropoffLat = vm.old_data.trip.dropoffLat;
      vm.data.trip.dropoffLng = vm.old_data.trip.dropoffLng;
      vm.data.trip.arrivalTransportLocator =
        vm.old_data.trip.arrivalTransportLocator;
      vm.data.trip.arrivalTransportLine = vm.old_data.trip.arrivalTransportLine;
      vm.data.trip.pickUpDate = vm.old_data.trip.pickUpDate;
      vm.data.trip.departureTransportDate =
        vm.old_data.trip.departureTransportDate;
      vm.data.trip.departureTransportLocator =
        vm.old_data.trip.departureTransportLocator;
    }

    // Limpiar cambios temporales en _search_confirm
    vm._search_confirm.from = null;
    vm._search_confirm.to = null;
    vm._search_confirm.from_view = null;
    vm._search_confirm.to_view = null;
    vm._search_confirm.search_from = {};
    vm._search_confirm.search_to = {};
  };

  vm.resetAllChanges = function() {
    if (!vm.old_data) {
      return;
    }

    // Restaurar información del cliente
    vm.data.customerFirstName = vm.old_data.customerFirstName;
    vm.data.customerLastName = vm.old_data.customerLastName;
    vm.data.customerEmail = vm.old_data.customerEmail;
    vm.data.customerPhone = vm.old_data.customerPhone;
    vm.data.customerCountry = vm.old_data.customerCountry;
    vm.data.specialRequirements = vm.old_data.specialRequirements;

    // Restaurar pasajeros
    vm.data.adults = vm.old_data.adults;
    vm.data.children = vm.old_data.children;
    vm.data.infants = vm.old_data.infants;
    vm.totalPassages =
      Number.parseInt(vm.data.children) +
      Number.parseInt(vm.data.adults) +
      Number.parseInt(vm.data.infants);

    // Restaurar vehículo
    if (vm.old_data.car) {
      vm.car = angular.copy(vm.old_data.car);
    }

    // Restaurar información de la ruta
    if (vm.old_data.trip) {
      vm.data.trip.pickup = vm.old_data.trip.pickup;
      vm.data.trip.dropoff = vm.old_data.trip.dropoff;
      vm.data.trip.pickupType = vm.old_data.trip.pickupType;
      vm.data.trip.dropoffType = vm.old_data.trip.dropoffType;
      vm.data.trip.pickUpLat = vm.old_data.trip.pickUpLat;
      vm.data.trip.pickUpLng = vm.old_data.trip.pickUpLng;
      vm.data.trip.dropoffLat = vm.old_data.trip.dropoffLat;
      vm.data.trip.dropoffLng = vm.old_data.trip.dropoffLng;
      vm.data.trip.arrivalTransportLocator =
        vm.old_data.trip.arrivalTransportLocator;
      vm.data.trip.arrivalTransportLine = vm.old_data.trip.arrivalTransportLine;
      vm.data.trip.pickUpDate = vm.old_data.trip.pickUpDate;
      vm.data.trip.departureTransportDate =
        vm.old_data.trip.departureTransportDate;
      vm.data.trip.departureTransportLocator =
        vm.old_data.trip.departureTransportLocator;
      vm.data.trip.departureTransportLine =
        vm.old_data.trip.departureTransportLine;
    }

    // Limpiar estados de edición
    vm.editingSection = null;
    vm.showfrom = false;
    vm.showto = false;
    vm._edit.from = false;

    // Limpiar cambios temporales en _search_confirm
    vm._search_confirm.from = null;
    vm._search_confirm.to = null;
    vm._search_confirm.from_view = null;
    vm._search_confirm.to_view = null;
    vm._search_confirm.search_from = {};
    vm._search_confirm.search_to = {};
    vm._search_confirm.adults = vm.old_data.adults;
    vm._search_confirm.children = vm.old_data.children;
    vm._search_confirm.infants = vm.old_data.infants;

    // Limpiar requote
    vm.qt = null;

    // Resetear vista de opciones de vehículos
    vm.showVehicleOptions = false;

    // Resetear validaciones
    vm.submit = false;
  };

  vm.onCloseConfirmation = function() {
    vm.submit = false;
    textChange = "";
    $("#c-modal-confirmation").modal("hide");
  };

  vm.getTotalReservation = function(obj = {}) {
    if (obj.currency == currencyDefault) {
      return obj.totalPrice * vm.exchange_convertion;
    }

    return obj.totalPrice || 0;
  };

  vm.getCurrencyReservation = function(obj = {}) {
    if (obj.currency == currencyDefault) {
      return vm.ln.currency_code;
    }
    return obj.currency || currencyDefault;
  };

  function reset() {
    _list = "";
    params = {};
    toggle = false;
    vm.loading_search = false;
    vm.loading = false;
    vm.results = [];
    vm.results_gm = [];
    vm.results_to = [];
    vm.results_gm_to = [];
    vm.results_pr = [];
    vm.results_pr_to = [];
    vm.search_in_places = false;
    vm.search_in_places_to = false;
    vm.qt = {
      type: "oneway",
      rs: true,
    };
    vm.nTransport = {};
    vm._search = {
      adults: 1,
      children: 0,
      infants: 0,
      search_from: {},
      search_to: {},
    };

    vm._search_confirm = {
      adults: 1,
      children: 0,
      infants: 0,
      search_from: {},
      search_to: {},
    };

    aux_trip = {};

    vm._edit = {
      from: false,
      to: false,
    };
    vm.valid_confirm = false;
    vm.statusShowChangeEmail = false;
    vm.data.send_email = "";
    vm.showVehicleOptions = false; // Resetear la vista de opciones de vehículos
    base_price_provider = 0;
  }
  function onSave() {
    // Validar qt antes de enviar: si tiene qt pero es inválido, no enviar
    if (vm.qt && vm.qt.type === 'options' && (!vm.qt.transport || vm.qt.code != 200)) {
      vm.loading = false;
      $("#c-modal-feedback").modal("show");
      return;
    }

    vm.loading = true;
    var user = __mt.setting.user || {};
    vm.data.bookingChanges = `\n<br/> ${textChange}`;
    var params = {
      data: vm.data,
      qt: vm.qt,
      lang: window.__mt.ln.lang,
    };

    var country = iti_r.getSelectedCountryData();
    if (country && country.dialCode) {
      phone_number = country.dialCode;
    }

    params.data.code_customerPhone =
      "(+" + phone_number + ") " + params.data.customerPhone;
    params.data.specialRequirementsAll = setComment(
      last_comment != vm.data.specialRequirements
        ? vm.data.specialRequirements
        : null
    );
    params.booking = _booking;
    params.user_id = user.id;
    params.user_type = user.type;
    console.log(params);
    $http
      .post(window.__mt.setting.api_edit_reservation, params)
      .then(onSaveSuccess, onSaveError);
  }

  function onSaveSuccess(data) {
    vm.loading = false;
    var response = data.data;
    if (response && response.stripe) {
      stripe
        .redirectToCheckout({
          sessionId: response.stripe.id,
        })
        .then(function(result) {
          console.log(result);
        });
    }
    getReservations();
    //$('#c-modal-edit').modal('hide');
    $("#c-modal-confirmation").modal("hide");
    // $(".ca-container").hide();
    // $("#id-reservation").show();
    $(".modal").modal("hide");
    vm.timeoutStop();
  }

  function onSaveError(data) {
    console.log(data);
    vm.loading = false;
    $("#c-modal-confirmation").modal("hide");
    $(".modal").modal("hide");
    vm.timeoutStop();
    $("#c-modal-feedback").modal("show");
  }

  function onLoadResults() {
    window.map_load = true;

    if (!autocompleteService) {
      if (!map) {
        onLoadMap();
      }
      autocompleteService = new google.maps.places.AutocompleteService();
      service = new google.maps.places.PlacesService(map);
    }

    autocompleteService.getPlacePredictions(
      {
        input: params.params.query,
      },
      responseGM
    );
  }

    function responseMT(data) {
      var response = data.data;
      vm.loading_search = false;
      var blockedPlaceIds = window.__mt.setting.blocked_place_ids || [];

      if (
        response &&
        response.code == 200 &&
        response.response &&
        !vm.search_in_places &&
        !vm.search_in_places_to
      ) {
        // Manejar resultados principales (destinos de MyTransfers)
        if (
          response.response.destinations &&
          response.response.destinations.length
        ) {
          vm["results" + _list] = response.response.destinations.filter(function(place) {
            return blockedPlaceIds.indexOf(place.place_id) === -1;
          });
        }

        // Manejar predicciones si están presentes
        if (
          response.response.predictions &&
          response.response.predictions.length
        ) {
          vm["results_pr" + _list] = response.response.predictions;
        } else {
          findInPlaces();
        }
      } else {
        findInPlaces();
      }
    }

  function responseGM(response, status) {
    if (status == "OK") {
            // Filtrar lugares bloqueados por place_id
            var blockedPlaceIds = window.__mt.setting.blocked_place_ids || [];
            var filteredResponse = response.filter(function(place) {
                return blockedPlaceIds.indexOf(place.place_id) === -1;
            });
      vm["results_gm" + _list] = filteredResponse;
    } else {
      vm["results_gm" + _list] = [];
    }
    vm.loading_search = false;
    $scope.$apply();
  }

  function get(url, params) {
    var defered = $q.defer();
    var promise = defered.promise;

    $http.get(url, params).then(
      function(data) {
        defered.resolve(data);
      },
      function(err) {
        defered.reject(err);
      }
    );

    return promise;
  }

  function onLoadMap() {
    window.map_load = true;

    var mapOptions = {
      center: new google.maps.LatLng(40.463667, -3.74922),
      zoom: 6,
      treetViewControl: false,
      mapTypeControl: false,
    };

    map = new google.maps.Map(
      document.getElementById("map_search"),
      mapOptions
    );

    marker = new google.maps.Marker({
      position: new google.maps.LatLng(40.463667, -3.74922),
      draggable: true,
    });
    marker.setMap(map);

    google.maps.event.addListener(marker, "click", function() {
      map.setZoom(9);
      map.setCenter(marker.getPosition());
    });

    google.maps.event.addListener(map, "click", function(event) {
      marker.setPosition(event.latLng);
    });
  }

  function getTypeGM(item) {
    var type = "address";

    if (item.types) {
      if (item.types.indexOf("train_station") != -1) {
        type = "train_station";
      }

      if (item.types.indexOf("airport") != -1) {
        type = "airport";
      }

      if (item.types.indexOf("port") != -1) {
        type = "port";
      }
    }

    return type;
  }

  function changePoint(item, dt, tp) {
    var type = item.type || getTypeGM(item);

    if (tp == "from") {
      aux_trip.pickup =
        item.name ||
        item.formatted_address ||
        item.description ||
        item.structured_formatting.main_text;
      aux_trip.pickupType = type;
    } else {
      aux_trip.dropoff =
        item.name ||
        item.formatted_address ||
        item.description ||
        item.structured_formatting.main_text;
      aux_trip.dropoffType = type;
    }
  }

  function changeConfirmTrip() {
    vm._search = vm._search_confirm;
    vm.data.trip.pickup = aux_trip.pickup || vm.data.trip.pickup;
    vm.data.trip.pickupType = aux_trip.pickupType || vm.data.trip.pickupType;
    vm.data.trip.dropoff = aux_trip.dropoff || vm.data.trip.dropoff;
    vm.data.trip.dropoffType = aux_trip.dropoffType || vm.data.trip.dropoffType;
  }

  function requote(showAll = false) {
    var from = vm._search_confirm.search_from || {};
    var to = vm._search_confirm.search_to || {};

    // Verificar si hay cambios de ruta (from y to tienen valores)
    var hasRouteChanges = (to.id || to.place_id) && (from.id || from.place_id);

    // Verificar si solo necesitamos requote sin cambio de ruta
    // (cuando hay cambios de pasajeros o se solicita lista de vehículos)
    var needsRequoteWithCurrentRoute =
      !hasRouteChanges &&
      vm.data.trip &&
      vm.data.trip.pickUpLat &&
      vm.data.trip.dropoffLat;

    if (hasRouteChanges || needsRequoteWithCurrentRoute) {
      // Procesar geometría solo si hay cambios de ruta
      if (hasRouteChanges) {
        if (
          vm._search_confirm.search_from.place_id &&
          !vm._search_confirm.search_from.geometry
        ) {
          getPlaceInformation("search_from");
          return;
        }

        if (
          vm._search_confirm.search_to.place_id &&
          !vm._search_confirm.search_to.geometry
        ) {
          getPlaceInformation("search_to");
          return;
        }

        if (
          vm._search_confirm.search_from.geometry &&
          vm._search_confirm.search_from.geometry.location &&
          typeof vm._search_confirm.search_from.geometry.location.lat ===
            "function"
        ) {
          vm._search_confirm.search_from.geometry.location.lat = vm._search_confirm.search_from.geometry.location.lat();
          vm._search_confirm.search_from.geometry.location.lng = vm._search_confirm.search_from.geometry.location.lng();
        }

        if (
          vm._search_confirm.search_to.geometry &&
          vm._search_confirm.search_to.geometry.location &&
          typeof vm._search_confirm.search_to.geometry.location.lat ===
            "function"
        ) {
          vm._search_confirm.search_to.geometry.location.lat = vm._search_confirm.search_to.geometry.location.lat();
          vm._search_confirm.search_to.geometry.location.lng = vm._search_confirm.search_to.geometry.location.lng();
        }
      }

      var user = __mt.setting.user || {};
      var params = {
        adults: vm._search_confirm.adults,
        infants: vm._search_confirm.infants,
        children: vm._search_confirm.children,
        lang: window.__mt.ln.lang,
        pickup_date: vm.data.trip.pickUpDate,
        // Si hay cambios de ruta, usar search_from/to; si no, usar trip actual
        origin_lat: hasRouteChanges
          ? vm._search_confirm.search_from.lat ||
            vm._search_confirm.search_from.geometry.location.lat
          : vm.data.trip.pickUpLat,
        origin_lng: hasRouteChanges
          ? vm._search_confirm.search_from.lng ||
            vm._search_confirm.search_from.geometry.location.lng
          : vm.data.trip.pickUpLng,
        destination_lat: hasRouteChanges
          ? vm._search_confirm.search_to.lat ||
            vm._search_confirm.search_to.geometry.location.lat
          : vm.data.trip.dropoffLat,
        destination_lng: hasRouteChanges
          ? vm._search_confirm.search_to.lng ||
            vm._search_confirm.search_to.geometry.location.lng
          : vm.data.trip.dropoffLng,
        transport_id: vm.car?.transportId || vm.data.transport_id,
        reservations_type: vm.data.type_reservation ? "roundtrip" : "oneway",
        provider_id: vm.car?.providerId || vm.data.provider_id,
        user_id: user.id,
        user_type: user.type,
        provider_price_id: vm.car?.providerPriceId || vm.data.provider_price_id,
        client_id: vm.data.client_id,
        get_available_cars: showAll,
      };
      console.log(params);
      vm.loading = true;
      $http
        .post(window.__mt.setting.api_requote, params)
        .then(onRequoteSuccess, onRequoteError);
    }
  }

  function onRequoteSuccess(data) {
    vm.loading = false;
    var response = data.data;
    requiredSelectVehicle(response);
    if (response.code == "200") {
      switch (response.type) {
        case "options":
          onOptions(response);
          break;
        case "no-found":
          noFound(response);
          break;
        case "oneway":
        case "roundtrip":
          onChangeTransport(response);
          break;
      }
      labelTrip();
    } else {
      noFound({
        type: "no-found",
      });
    }
    console.log("change", vm.data);
  }

  function onRequoteError(data) {
    vm.loading = false;
    console.log(data);

    // Si hay un cambio de ruta pendiente, mostrar error y restaurar valores
    if (vm._backup_search) {
      vm.routeChangeError = true;
      vm.resetRouteChanges();
      $scope.$apply();
    } else {
      noFound({
        type: "no-found",
      });
    }
  }

  function noFound(response) {
    vm.qt = response;
    vm.qt.rs = false;
    $("#c-modal-notification").modal("show");
  }

  function onOptions(response) {
    vm.qt = response;
    $("#c-modal-notification").modal("show");
  }

  function onChangeTransport(response) {
    vm.qt = response;
    vm.qt.transport = response.response.transfer;

    if (base_price_provider == vm.qt.transport.providerPrice) {
      vm.qt.transport.price = vm.data.price.totalPrice;
    }

    vm.qt.rs = true;
    console.log("CAMBIADO AUTOMATICO");
  }

  function getPlaceInformation(type) {
    var item = vm._search[type];

    // Si el item ya tiene lat/lng directamente (predictions), usarlos sin llamar a Google
    if (item.lat && item.lng) {
      vm._search[type].geometry = {
        location: {
          lat: item.lat,
          lng: item.lng,
        },
      };
      requote();
      return;
    }

    // Si tiene place_id pero service no está inicializado, mostrar error
    if (!service) {
      console.error("Google Maps service not initialized");
      vm.routeChangeError = true;
      if (vm._backup_search) {
        vm.resetRouteChanges();
      }
      $scope.$apply();
      return;
    }

    var request = {
      placeId: item.place_id,
      fields: ["name", "rating", "formatted_phone_number", "geometry"],
    };
    service.getDetails(request, (response) => {
      vm._search[type] = vm._search[type] || {};
      vm._search[type].geometry = {};
      vm._search[type].geometry.location = {};
      vm._search[type].geometry.location.lat = response.geometry.location.lat();
      vm._search[type].geometry.location.lng = response.geometry.location.lng();
      $scope.$apply();
      requote();
    });
  }

  function optionCarDeselect() {
    for (let index = 0; index < vm.qt.options.length; index++) {
      const element = vm.qt.options[index];
      element.selected = false;
    }
  }

  function requiredSelectVehicle(res = null) {
    let option = res.options;
    let required = true;
    vm.isRequiredSelectVehicle = false;
    if (res) {
      if (option.allTransfers) {
        required = false;
      } else if (option.searchedTransfer) {
        required = false;
      }
    }
    /**if(total <= vm.car.maxPassengers || getAllAvailableCars){
            required = false;
        }**/
    vm.isRequiredSelectVehicle = required;
  }
  function showAlertInit() {
    var item = vm.data && vm.data.trip ? vm.data.trip : null;
    //var search_to = vm.data && vm.data.search_to ? vm.data.search_to : null;
    showAlert(item, false, true); // rountrip =  false
    //showAlert(search_to, 'to');
  }
  function showAlert(item, round_trip, reverse = false) {
    var property = "pickup";
    var property_round = "dropoff";

    if (!item) {
      vm.msn[property].display = "none";
      vm.msn[property].msn = "";
      vm.msn[property_round].display = "none";
      vm.msn[property_round].msn = "";
      return;
    }
    var destination = item.pickupType;
    var destination_to;
    var search_to = item && item.dropoffType ? item : null;
    if (search_to) {
      destination_to = search_to.dropoffType;
    }
    if (destination_to && destination == "airport") {
      vm.msn[property].display = "block";
      vm.msn[property].msn = vm.ln["msn_searchbox_date_" + property];
    } else if (
      destination_to &&
      destination == "address" &&
      destination_to == "airport"
    ) {
      vm.msn[property].display = "block";
      vm.msn[property].msn = vm.ln["msn_searchbox_date_dropoff"];
    } else {
      vm.msn[property].display = "block";
      vm.msn[property].msn = vm.ln["msn_searchbox_pickuptime"];
    }

    if (!round_trip) {
      if (destination && destination_to == "airport") {
        vm.msn[property_round].display = "block";
        vm.msn[property_round].msn = vm.ln["msn_searchbox_date_pickup"];
      } else if (
        destination &&
        destination_to == "address" &&
        destination == "airport"
      ) {
        vm.msn[property_round].display = "block";
        vm.msn[property_round].msn = vm.ln["msn_searchbox_date_dropoff"];
      } else {
        vm.msn[property_round].display = "block";
        vm.msn[property_round].msn = vm.ln["msn_searchbox_pickuptime"];
      }
    } else {
      vm.msn[property_round].display = "block";
      vm.msn[property_round].msn = vm.ln["msn_searchbox_pickuptime"];
    }
  }
  function getMessagePicker(type) {
    $scope.$apply(() => {
      let destination;
      if (type) {
        if (type == "pickup") {
          destination = vm.data.trip.pickupType;
        } else {
          destination = vm.data.trip.dropoffType;
        }
      }
      vm.msn.selected = destination ?? "default";
    });
    let documents = document.querySelectorAll(
      ".daterangepicker.ltr.single.opensright.show-calendar .calendar-time"
    );
    document
      .querySelectorAll(
        ".daterangepicker.ltr.single.opensright.show-calendar .messagePicker"
      )
      .forEach((res) => {
        res.remove();
      });
    documents.forEach((doc) => {
      doc.insertAdjacentHTML(
        "beforebegin",
        `<div class="messagePicker">${vm.msn.messages[vm.msn.selected] ||
          ""}</div>`
      );
    });
  }

  function showTooltip(type, record) {
    var is_address = record.type || getTypeGM(record);

    if (is_address == "address") {
      $("#" + type + "_view_edit_tooltip").tooltip("show");

      setTimeout(function() {
        $("#" + type + "_view_edit_tooltip").tooltip("hide");
      }, 6000);
    }
  }

  function validConfirmEmail() {
    var email_customer = (vm.data.customerEmail || "").toLowerCase();
    var email_customer_confirm = (vm.data.confirm_email || "").toLowerCase();
    return email_customer == email_customer_confirm;
  }

  function getLastComment(comt) {
    vm.allComments = comt.split(delimiter);
    last_comment = vm.allComments[vm.allComments.length - 1];
    return last_comment;
  }

  function setComment(comment) {
    if (comment) {
      vm.allComments.push(comment);
    }
    return vm.allComments.join(delimiter);
  }

  /****
   *    End Code
   ****/
  vm.agency_data = {};
  vm.sendEmailVoucher = function(reservation) {
    vm.agency_data = {};
    console.log(reservation, "send voucher");
    $("#c-modal-email-change").modal("show");
    vm.agency_data.id =
      reservation.booking_id ||
      reservation.bookingReference ||
      reservation.id ||
      reservation.Id;
    vm.agency_data.email =
      reservation.email || reservation.customerEmail || vm._s.email;
    vm.agency_data.lang = window.__mt.ln.lang;
  };
  vm.onSubmitEmailVoucher = function(form) {
    vm.agency_data.submit = true;
    if (form.$valid) {
      console.log(vm.agency_data, form);
      vm.loading = true;
      $http
        .post(window.__mt.setting.api_voucher_emal, vm.agency_data)
        .then(onResetEmailVoucher, getBookingError);
    }
  };

    vm.downloadVoucher =  () => {
        vm.loading = true;

        $http({
            method: 'GET',
            url: window.__mt.setting.url_voucher_download,
            params: vm.agency_data,
            responseType: 'blob',
            timeout: 120000
        }).then(function(response) {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = vm.agency_data.id + ".pdf";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();

            vm.loading = false;
            $("#c-modal-email-change").modal("hide");
        }).catch(function(error) {
            console.error('Error downloading PDF:', error);
            vm.loading = false;
            alert('Error generating PDF. Please try again.');
        });
    }

  function onResetEmailVoucher(data) {
    var response = data.data;
    vm.loading = false;
    if (response.code == 200) {
      vm.agency_data = {};
      $("#c-modal-email-change").modal("hide");
    } else {
      getBookingError(response);
    }
  }

    function redirectVoucher(){
        vm.loading = true;       
        $http.get(window.__mt.setting.url_voucher_download,{params:vm.agency_data}).then(onRedirect,redirectError);
    }

    function onRedirect(data){     
         var response = data.data;        
        if(response.success){
            window.open(response.success,'_blank');           
        }else if(response.error){
            redirectError();
        }
        vm.loading = false;
    }

    function redirectError(){
        console.error('Error al generar el voucher');
    }

    function downloadFile(params, url) {
        const query = new URLSearchParams(params).toString();
        url = url + "?" + query;
        const a = document.createElement("a");
        console.log(url);
        a.href = url;
        a.download = params.id + ".pdf";
        a.setAttribute("target", "_blank")
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();

    }
}
